module.exports = __webpack_public_path__ + "static/media/ice-cream.da704b6c.png";